import type { ProviderOperationsAction } from "libs/apiClient";

export const PROVIDER_OPERATIONS_ACTION_LABEL_KEYS: Record<ProviderOperationsAction, string> = {
	refresh_status: "providerOperations.action.refreshStatus",
	process_pending: "providerOperations.action.processPending",
	sync: "providerOperations.action.sync",
};
